<template>
<Dialog title="Wybierz opcje" :on-ok="onOk" :on-cancel="onCancel" :on-close="onClose">
    <template v-slot:body>
        <div class="row">
            <div class="col-10">
                Sprawdzenie i oznaczenie zmienionych zdjęć
            </div>
            <div class="col-2">
                <input-field type="switch" name="check_for_changes" v-model="options.check_for_changes"></input-field>
            </div>
        </div>
        <div class="row">
            <div class="col-10">
                Pobranie oznaczonych zdjęć (200 szt.)
            </div>
            <div class="col-2">
                <input-field type="switch" name="download_pictures" v-model="options.download_pictures"></input-field>
            </div>
        </div>

    </template>
</Dialog>
</template>

<script>
import Dialog from "@/pages/Common/Dialog";
import InputField from "@/components/Forms/InputField";
export default {
    name: "TestDialog",
    components: {
        InputField,
        Dialog
    },
    props: {
        afterOk: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            options: {
                check_for_changes: true,
                download_pictures: true,
            }
        }
    },
    methods: {
        onClose() {
            console.log('onClose');
            this.$emit('close');
        },
        onOk() {
            localStorage.setItem('download_yacht_pictures_options', JSON.stringify(this.options));
            if (this.afterOk) {
                this.afterOk(this.options)
            }
            this.$emit('close');
        },
        onCancel() {
            this.$emit('close');
        }
    },
    created() {
        let jsonOptions = localStorage.getItem('download_yacht_pictures_options');
        if (jsonOptions) {
            let options = JSON.parse(jsonOptions);
            console.log('options', options);
            if (options) {
                this.options = options;
            }
        }
    }
}
</script>

<style scoped>

</style>